module.exports = __webpack_public_path__ + "static/media/de.fc644b73.png";